import { render, staticRenderFns } from "./SterlingHuman.vue?vue&type=template&id=944a3366&scoped=true"
import script from "./SterlingHuman.vue?vue&type=script&lang=js"
export * from "./SterlingHuman.vue?vue&type=script&lang=js"
import style0 from "./SterlingHuman.vue?vue&type=style&index=0&id=944a3366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944a3366",
  null
  
)

export default component.exports